// src/pages/Dashboard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

export default function Dashboard() {
  const { user, can } = useAuth();
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get('/forms?limit=5').then(r => {
      setRecent(r.data.data);
      setStats({ total: r.data.total });
    });
  }, []);

  const statCards = [
    { label:'کۆی فۆرمەکان', value: stats?.total ?? '...', icon:'📋', color:'#1a5276' },
    { label:'بەشی تۆ', value: user?.dept_name || '—', icon:'🏢', color:'#1e8449' },
    { label:'ڕۆڵی تۆ', value: { admin:'ئەدمین', data_entry:'داخڵکەر', viewer:'بینەر', report:'ڕاپۆرت' }[user?.role], icon:'👤', color:'#7d3c98' },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>بەخێرهاتیت، {user?.full_name} 👋</h1>
          <p style={styles.sub}>سیستەمی دەرماڵەی خێزانداری و منداڵان</p>
        </div>
        {can('create') && (
          <button onClick={() => nav('/forms/new')} style={styles.newBtn}>
            ➕ فۆرمی نوێ
          </button>
        )}
      </div>

      <div style={styles.cards}>
        {statCards.map((c,i) => (
          <div key={i} style={{...styles.card, borderTop:`4px solid ${c.color}`}}>
            <div style={styles.cardIcon}>{c.icon}</div>
            <div style={styles.cardVal}>{c.value}</div>
            <div style={styles.cardLabel}>{c.label}</div>
          </div>
        ))}
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>📋 فۆرمە دوایینەکان</h2>
        <div style={styles.table}>
          <table style={styles.tbl}>
            <thead>
              <tr style={styles.thead}>
                <th style={styles.th}>ژمارەی فۆرم</th>
                <th style={styles.th}>ناوی فەرمانبەر</th>
                <th style={styles.th}>بەش</th>
                <th style={styles.th}>منداڵ</th>
                <th style={styles.th}>بەروار</th>
                <th style={styles.th}>کردار</th>
              </tr>
            </thead>
            <tbody>
              {recent.map(f => (
                <tr key={f.id} style={styles.tr}>
                  <td style={styles.td}><span style={styles.badge}>{f.form_number}</span></td>
                  <td style={styles.td}>{f.employee_name}</td>
                  <td style={styles.td}>{f.dept_name}</td>
                  <td style={styles.td}>{f.children_count}</td>
                  <td style={styles.td}>{new Date(f.created_at).toLocaleDateString('ku')}</td>
                  <td style={styles.td}>
                    <button onClick={() => nav(`/forms/${f.id}`)} style={styles.viewBtn}>بینین</button>
                  </td>
                </tr>
              ))}
              {recent.length === 0 && (
                <tr><td colSpan={6} style={{...styles.td, textAlign:'center', color:'#999'}}>هیچ فۆرمێک نیە</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {stats?.total > 5 && (
          <button onClick={() => nav('/forms')} style={styles.allBtn}>
            هەموو فۆرمەکان بینین ({stats.total}) ←
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { padding:24 },
  header: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 },
  title: { fontSize:22, fontWeight:'bold', color:'#1a5276', margin:0 },
  sub: { fontSize:13, color:'#666', margin:'4px 0 0' },
  newBtn: { background:'linear-gradient(135deg,#1a5276,#2980b9)', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:'bold', cursor:'pointer' },
  cards: { display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:16, marginBottom:24 },
  card: { background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', textAlign:'center' },
  cardIcon: { fontSize:32, marginBottom:8 },
  cardVal: { fontSize:20, fontWeight:'bold', color:'#222', marginBottom:4 },
  cardLabel: { fontSize:12, color:'#888' },
  section: { background:'#fff', borderRadius:10, padding:20, boxShadow:'0 2px 8px rgba(0,0,0,0.08)' },
  sectionTitle: { fontSize:16, fontWeight:'bold', color:'#1a5276', marginBottom:16 },
  table: { overflowX:'auto' },
  tbl: { width:'100%', borderCollapse:'collapse' },
  thead: { background:'#f0f4f8' },
  th: { padding:'10px 12px', textAlign:'right', fontSize:12, fontWeight:'bold', color:'#555', borderBottom:'2px solid #e0e0e0' },
  tr: { borderBottom:'1px solid #f0f0f0', transition:'background 0.1s' },
  td: { padding:'10px 12px', fontSize:13, color:'#333' },
  badge: { background:'#eaf2fb', color:'#1a5276', borderRadius:4, padding:'2px 8px', fontSize:11, fontWeight:'bold' },
  viewBtn: { background:'#eaf2fb', color:'#1a5276', border:'1px solid #1a5276', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontSize:12 },
  allBtn: { marginTop:12, background:'none', border:'none', color:'#1a5276', cursor:'pointer', fontSize:13, fontWeight:'bold' },
};
